import Vue from 'vue'

export default function setupDefaultDirectives() {
  // usage is for click outside events
  // more info: https://stackoverflow.com/questions/36170425/detect-click-outside-element
  // https://jsfiddle.net/70vm3jrd/1/
  Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
      el.clickOutsideEvent = function (event) {
        // check that click was outside the el and his childrens
        // eslint-disable-next-line eqeqeq
        if (!(el == event.target || el.contains(event.target))) {
          // and if it is, call method provided in attribute value
          vnode.context[binding.expression](event)
        }
      }
      document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
      document.body.removeEventListener('click', el.clickOutsideEvent)
    },
  })
}



// WEBPACK FOOTER //
// ./src/directives.js